module.exports = __webpack_public_path__ + "img/T2.d259bb34.png";